import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';
import { StyledShoppingItemContainer } from './StyledShoppingItem';

const SkeletonShoppingItem = () => {
  return (
    <StyledShoppingItemContainer>
      <Flex w="100%" justifyContent="space-between">
        <Flex gap="4px">
          <Flex direction="column">
            <SkeletonText noOfLines={1} width="80px" />
            <SkeletonText mt="12px" noOfLines={1} width="120px" />
            <Skeleton mt="12px" width="80px" height="20px" />
          </Flex>
        </Flex>
        <Flex
          direction="column"
          alignItems={'end'}
          minH="76px"
          justifyContent={'space-between'}
        >
          <SkeletonText noOfLines={1} width="50px" />
        </Flex>
      </Flex>
    </StyledShoppingItemContainer>
  );
};

export default SkeletonShoppingItem;
